/**
 * "You have joined the waitlist!" confirmation toast (HORO-10471) per Figma
 * 4440:28056 (mobile) / 4481:21316 (desktop) — identical on both.
 *
 * Shown after a user joins from the promo modal and is routed back to their
 * conversation. Anchored to the top of the viewport, so it structurally cannot
 * cover the message composer at the bottom.
 *
 * HORO-10509: now a thin wrapper around the generic <Toast> (extracted from
 * this component so the auth flow could reuse the exact same visual
 * pattern) — behavior/timing/copy are unchanged from before the extraction.
 */
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getShowJoinedToast, setShowJoinedToast } from '../../../store/slices/waitlistSlice';
import Toast from '../Toast';

const LiveReadingsToast = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isVisible = useSelector(getShowJoinedToast);

    return (
        <Toast
            show={isVisible}
            message={t('liveReadings.toastJoined')}
            dismissLabel={t('liveReadings.toastDismiss')}
            onDismiss={() => dispatch(setShowJoinedToast(false))}
        />
    );
};

export default LiveReadingsToast;
